import { render, staticRenderFns } from "./AddProductMaster.vue?vue&type=template&id=cab52868&"
import script from "./AddProductMaster.vue?vue&type=script&lang=js&"
export * from "./AddProductMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports